import { replaceUrlDomain } from "@src/utils/domain-utils";

if (!window.isSetOpen) {
  const oldOpen = window.open;
  window.open = (url, target, features) => {
    return oldOpen(replaceUrlDomain(url), target, features);
  };
  window.isSetOpen = true;
}

// 设置域名方法
function setDomain() {
  let config = {
    docDomain: `https://open-doc.welink.huaweicloud.com`,
    techStandardWelinkDomain: `http://tech-standard.welink.huawei.com`,
    huaweicloud: `huaweicloud.com`,
    static: "static.hc-cdn.com"
  };
  let backHostName = window.location.hostname;
  const isIcslEnv = backHostName.includes("icsl");
  if (isIcslEnv) {
    backHostName = backHostName.replace("open-icsl.", "");
    config = {
      // 登录域名
      loginDomain: `https://login-icsl.${backHostName}`,
      // 管理后台域名
      backEndDomain: `https://icsl.${backHostName}`,
      // 平台面域名
      masterDomain: `https://master-icsl.${backHostName}`,
      // api域名
      apiDomain: `https://api-icsl.${backHostName}`,
      welink: backHostName,
      ...config
    };
  } else {
    backHostName = backHostName.replace("open.", "");
    config = {
      // 登录域名
      loginDomain: `https://login.${backHostName}`,
      // 管理后台域名
      backEndDomain: `https://${backHostName}`,
      // 平台面域名
      masterDomain: `https://master.${backHostName}`,
      // api域名
      apiDomain: `https://api.${backHostName}`,
      welink: backHostName,
      ...config
    };
  }
  let currentDomain = config;
  window._domain_ = currentDomain;
  window.__baseDomain = {
    huaweicloud: currentDomain.huaweicloud,
    welink: currentDomain.welink,
    static: currentDomain.static
  };
}

setDomain();
